module.exports = __webpack_public_path__ + "static/media/21ECLAC1.05e84b57.jpg";